import { render, staticRenderFns } from "./inviteEntp.vue?vue&type=template&id=f0b0620e&scoped=true&"
import script from "./inviteEntp.vue?vue&type=script&lang=js&"
export * from "./inviteEntp.vue?vue&type=script&lang=js&"
import style0 from "./inviteEntp.vue?vue&type=style&index=0&id=f0b0620e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b0620e",
  null
  
)

component.options.__file = "inviteEntp.vue"
export default component.exports